import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=1788697c"
import script from "./distributor.vue?vue&type=script&lang=js"
export * from "./distributor.vue?vue&type=script&lang=js"
import style0 from "./distributor.vue?vue&type=style&index=0&id=1788697c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports